import React from 'react'
import cn from 'classnames'
import PermissionOption from './PermissionOption'

type PermissionUser = {
  id: string
  username?: string
  [key: string]: unknown
}

type PermissionSearchState = {
  isFetching: boolean
  results: PermissionUser[]
}

type PermissionActionPayload = {
  id: string
  username?: string | undefined
}

type PermissionOptionListProps = {
  readers: Record<string, PermissionUser>
  writers: Record<string, PermissionUser>
  creator?: PermissionUser
  users?: PermissionSearchState
  viewOnly?: boolean | undefined
  addReader?: ((payload: PermissionActionPayload) => void) | undefined
  removeReader?: ((payload: { id: string }) => void) | undefined
  addWriter?: ((payload: PermissionActionPayload) => void) | undefined
  removeWriter?: ((payload: { id: string }) => void) | undefined
}

const PermissionOptionList = ({ viewOnly, users, readers, writers, creator, addReader, removeReader, addWriter, removeWriter }: PermissionOptionListProps) => {
  return (
    <div className={cn('permissions-options')}>
      {creator?.id ? <PermissionOption key={`creator-${creator.id}`} user={creator} isCreator={true} viewOnly={true} /> : null}
      {Object.values(writers).map((user: PermissionUser) => (
        <PermissionOption
          key={`writer-${user.id}`}
          user={user}
          canRead={true}
          canWrite={true}
          addReader={addReader}
          removeReader={removeReader}
          addWriter={addWriter}
          removeWriter={removeWriter}
          viewOnly={viewOnly}
        />
      ))}
      {Object.values(readers).map((user: PermissionUser) => {
        if (writers[user.id]) {
          return null
        }
        return (
          <PermissionOption
            key={`reader-${user.id}`}
            user={user}
            canRead={true}
            canWrite={false}
            addReader={addReader}
            removeReader={removeReader}
            addWriter={addWriter}
            removeWriter={removeWriter}
            viewOnly={viewOnly}
          />
        )
      })}
      {users?.results?.length ? <hr /> : null}
      {users?.results?.length
        ? users.results.map((user: PermissionUser) => {
            if (readers[user.id]) {
              return null
            }
            return (
              <PermissionOption
                key={`option-${user.id}`}
                user={user}
                canRead={!!readers[user.id]}
                canWrite={!!writers[user.id]}
                addReader={addReader}
                removeReader={removeReader}
                addWriter={addWriter}
                removeWriter={removeWriter}
              />
            )
          })
        : null}
    </div>
  )
}

export default PermissionOptionList
